var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCloseModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2099 6.20711C19.6004 5.81658 19.6004 5.18342 19.2099 4.79289C18.8194 4.40237 18.1862 4.40237 17.7957 4.79289L12.0014 10.5872L6.20711 4.7929C5.81658 4.40238 5.18342 4.40238 4.79289 4.7929C4.40237 5.18343 4.40237 5.81659 4.79289 6.20712L10.5872 12.0014L4.79289 17.7957C4.40237 18.1862 4.40237 18.8194 4.79289 19.2099C5.18342 19.6004 5.81658 19.6004 6.20711 19.2099L12.0014 13.4156L17.7957 19.2099C18.1862 19.6004 18.8194 19.6004 19.2099 19.2099C19.6004 18.8194 19.6004 18.1862 19.2099 17.7957L13.4156 12.0014L19.2099 6.20711Z",
    fill: "#6D6970"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCloseModal);
export default __webpack_public_path__ + "static/media/ico-close-modal.b1607425a3b5cabfeec0e75cd1932286.svg";
export { ForwardRef as ReactComponent };